import { create } from 'zustand';
import i18n, { use } from "i18next";

import { apiDomain, basename } from '../setting';
import useModalStore from './useModalStore';
import useAuthStore from './useAuthStore';
import useLoadingStore from './useLoadingStore';
import withErrorHandling from '../function/withErrorHandling';
import feWriteLog from '../function/feWriteLog';

const useApplyNewStore = create((set, get) => ({
    step: "0",
    setStep: (value) => set((state) => {
        return { step: value }
    }),
    resetStep: () => set((state) => {
        return { step: "0" }
    }),
    resetApplyData: () => set((state) => {
        return {
            step: "0",
            getPreAuthFormData: {},

            isStep0Valid: false,
            step1_section2_disease: [
                {
                    diseaseCode: "",
                    surgeryCode: "",
                }
            ],
            step1_section2_disease_error: [
                {
                    diseaseCode: false,
                    surgeryCode: [false],
                }
            ],

            step1_section2_attendDoctor: "",
            step1_section2_attendDoctor_error: false,
            step1_section2_isBxNetwork: "",

            step1_section2_operationloctype: "HOSPITAL",
            step1_section2_location: "HKMU",
            step1_section2_hospitalid: {

            },
            step1_section2_hospitalid_error: false,
            step1_section2_otherhopsital: "",
            step1_section2_otherhopsital_error: false,

            step1_section2_housingclass: "",
            step1_section2_housingclass_error: false,
            step1_section3_admissiondt: "",
            step1_section3_admissiondt_error: false,
            step1_section3_surgeryBudgetRemark: "",

            step1_section3_provideMedicalExpense: false,
            step1_section3_surgeonfee: "",
            step1_section3_surgeonfee_checkbox: false,
            step1_section3_surgeonfee_error: false,
            step1_section3_anesthesiologistfee: "",
            step1_section3_anesthesiologistfee_checkbox: false,
            step1_section3_anesthesiologistfee_error: false,
            step1_section3_operatingrmfee: "",
            step1_section3_operatingrmfee_checkbox: false,
            step1_section3_operatingrmfee_error: false,
            step1_section3_housetourfee: "",
            step1_section3_hosmisousfee_checkbox: false,
            step1_section3_housetourfee_error: false,
            step1_section3_hosmisousfee: "",
            step1_section3_hosmisousfee_error: false,
            step1_section3_noofdays: "",
            step1_section3_noofdays_error: false,
            step1_section3_housetourfee_noofdays_checkbox: false,

            step1_notToPaid: true,
            isStep1Valid: false,

            step2_upload_option1: false,
            step2_upload_option2: false,
            step2_doc: [],
            step2_doc_error: false,

            step3_email: "",
            step3_email_error: false,
            step3_email_confirm: "",
            step3_email_confirm_error: false,
            step3_sync: false,
            step3_Q1: "",
            step3_Q1Error: false,
            step3_Q4: "person",
            step3_Q5: "",
            step3_Q5Error: false,
            step3_Q6: "",
            step3_Q6Error: false,
            step3_Q7: "",
            step3_Q7Error: false,
            step3_scrollTo: "",
            isStep3Valid: false,

            step4_accept: false,

            refno: "",
            stepSuccess_rateOverall: 5,
            stepSuccess_rateOverall_error: false,
            stepSuccess_rateImproveCode: "",
            stepSuccess_rateImproveCode_error: false,
            stepSuccess_rateCmt: "",
            stepSuccess_rateCmt_error: false,
            isRatingValid: false,
            disableRatingSubmit: false,
        }
    }),
    goNextStep: withErrorHandling(async () => {
        const { step, setStep, getPreAuthFormData, getPreAuthForm, getPreAuthFormForStep4, getHospitalList, saveFormStep1, saveFormStep2, saveFormStep3 } = get();
        const { step1_notToPaid } = get();
        const { isLogCase, goMPGSPayment, applicationSubmit } = get();
        const { userAuthenticate } = useAuthStore.getState();

        switch (step) {
            case "0":
                const success = await userAuthenticate();

                if (success) {
                    await getHospitalList();
                    await getPreAuthForm();
                }

                break;

            case "1":
                await saveFormStep1();
                setStep("2");
                break;

            case "2":
                await saveFormStep2();
                setStep("3");
                break;

            case "3":
                await saveFormStep3();
                await getPreAuthFormForStep4();
                setStep("4");
                break;

            case "4":
                // if (isLogCase() && !step1_notToPaid) {
                if (getPreAuthFormData?.form?.triggerPaymentGateway === "Y") {
                    await goMPGSPayment();
                } else {
                    const success = await applicationSubmit();

                    if (success) {
                        setStep("success");
                        window.history.pushState({}, '', `/${basename}/${i18n.language}/apply/success`);
                    } else {
                        setStep("submitFail");
                    }
                }
                break;

            default:
                break;
        }
    }),
    goBackStep: withErrorHandling(async () => {
        const { step, setStep } = get();
        const { openModalConfirm } = useModalStore.getState();

        switch (step) {
            case "1":
                openModalConfirm({
                    title: i18n.t("translation:apply.nav.exitTitle"),
                    text: i18n.t("translation:apply.nav.exitContent"),
                    callback: () => {
                        setStep("0");
                    }
                });
                break;

            case "2":
                setStep("1");
                break;

            case "3":
                setStep("2");
                break;

            case "4":
                setStep("3");
                break;

            default:
                break;
        }
    }),

    saveForm: async (item) => {
        const { token, logout } = useAuthStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/savePreAuthForm`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(item)
        });

        if (response.status === 401) { // Unauthorized
            logout();
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            throw new Error('Network Error');
        }

        return await response.json();
    },

    // # Step 0
    // Value: 保單號碼
    step0_Q1: "",
    step0_Q1Error: false,
    setStep0_Q1: (value) => {
        const { validateStep0 } = get();

        set({ step0_Q1: value });
        validateStep0(true);
    },
    setStep0_Q1Error: (value) => set({ step0_Q1Error: value }),

    // Value: 受保人（病人）姓名
    step0_Q2: "",
    step0_Q2Error: false,
    setStep0_Q2: (value) => {
        const { validateStep0 } = get();

        set({ step0_Q2: value });
        validateStep0(true);
    },
    setStep0_Q2Error: (value) => set({ step0_Q2Error: value }),

    // Value: 受保人（病人）之出生日期
    step0_Q3: "",
    step0_Q3Error: false,
    setStep0_Q3: (value) => {
        const { validateStep0 } = get();

        set({ step0_Q3: value });
        validateStep0(true);
    },
    setStep0_Q3Error: (value) => set({ step0_Q3Error: value }),

    // Value: 受保人（病人）於該保單之身份為
    step0_Q4: "person",  // person, spouse_children
    setStep0_Q4: (value) => set({ step0_Q4: value }),

    // Value: 受保人（病人）之成員號碼
    step0_Q5: "",
    step0_Q5Error: false,
    setStep0_Q5: (value) => {
        const { validateStep0 } = get();

        set({ step0_Q5: value });
        validateStep0(true);
    },
    setStep0_Q5Error: (value) => set({ step0_Q5Error: value }),

    // Value: 申請人受保人號碼
    step0_Q6: "",
    step0_Q6Error: false,
    setStep0_Q6: (value) => {
        const { validateStep0 } = get();

        set({ step0_Q6: value });
        validateStep0(true);
    },
    setStep0_Q6Error: (value) => set({ step0_Q6Error: value }),

    // Value: 配偶或子女受保人號碼
    step0_Q7: "",
    step0_Q7Error: false,
    setStep0_Q7: (value) => {
        const { validateStep0 } = get();

        set({ step0_Q7: value });
        validateStep0(true);
    },
    setStep0_Q7Error: (value) => set({ step0_Q7Error: value }),

    // Scroll to
    step0_ScrollTo: "",
    setStep0_ScrollTo: (value) => set({ step0_ScrollTo: value }),

    // Validation
    isStep0Valid: false,
    validateStep0: (checkOnly) => {
        const { step0_Q1, step0_Q2, step0_Q3, step0_Q4, step0_Q5, step0_Q6, step0_Q7 } = get();
        const { setStep0_Q1Error, setStep0_Q2Error, setStep0_Q3Error, setStep0_Q5Error, setStep0_Q6Error, setStep0_Q7Error } = get();
        const { step0_ScrollTo } = get();

        // Reset errors
        // const resetErrors = [setStep0_Q1Error, setStep0_Q2Error, setStep0_Q3Error, setStep0_Q5Error, setStep0_Q6Error, setStep0_Q7Error];
        // resetErrors.forEach(resetError => resetError(false));

        const validations = [
            { condition: !step0_Q1, setError: setStep0_Q1Error, scrollTo: "step0_Q1" },
            { condition: !step0_Q2, setError: setStep0_Q2Error, scrollTo: "step0_Q2" },
            { condition: !step0_Q3, setError: setStep0_Q3Error, scrollTo: "step0_Q3" },
            { condition: step0_Q4 === "person" && !step0_Q5, setError: setStep0_Q5Error, scrollTo: "step0_Q5" },
            { condition: step0_Q4 === "spouse_children" && !step0_Q6, setError: setStep0_Q6Error, scrollTo: "step0_Q6" },
            { condition: step0_Q4 === "spouse_children" && !step0_Q7, setError: setStep0_Q7Error, scrollTo: "step0_Q7" },
        ];

        let allValid = true;

        validations.forEach(({ condition, setError, scrollTo }) => {
            if (condition) {
                if (!checkOnly) {
                    setError(true);
                    if (allValid && !step0_ScrollTo && scrollTo) {
                        set({ step0_ScrollTo: scrollTo });
                    }
                }
                allValid = false;
            }
        });

        set({ isStep0Valid: allValid });
        return allValid;
    },

    // Step 1 get data
    getPreAuthFormData: {},
    getPreAuthForm: async () => {
        const { resetApplyData, hospitalList } = get();
        const { validateStep1, validateStep2, validateStep3 } = get();
        const { openModalConfirm } = useModalStore.getState();

        const { token } = useAuthStore.getState();
        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/getPreAuthForm`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });

        if (response.status === 401) { // Unauthorized
            throw new Error('Unauthorized Signin');
        }

        if (!response.ok) {
            throw new Error('Network Error');
        }

        const data = await response.json();

        if (data.form.step === "0" || data.form.step === null) {
            resetApplyData();

            set({
                step0_Q1: "",
                step0_Q2: "",
                step0_Q3: "",
                step0_Q4: "person",
                step0_Q5: "",
                step0_Q6: "",
                step0_Q7: "",

                step: "1",
                getPreAuthFormData: data,
            });
        } else {
            openModalConfirm({
                title: i18n.t("translation:apply.step0.popup.title"),
                text: i18n.t("translation:apply.step0.popup.content"),
                callback: () => {
                    resetApplyData();

                    const hospital = data.form.hospitalid ? hospitalList.find(item => item.hid === data.form.hospitalid) : {};
                    const hospitalItem = hospital ? {
                        value: data.form.hospitalid,
                        label: i18n.language === "ch" ? hospital.chi_name : hospital.eng_name,
                        color: "var(--aia-bx-dark-blue)",
                    } : {};

                    const handledDiseaseInfo = data.form.diseaseInfo.map((item) => {
                        return {
                            ...item,
                            diseaseCode: item.diseaseOther ? `${item.diseaseCode}|${item.diseaseOther}` : item.diseaseCode,
                        }
                    });

                    set({
                        step0_Q1: "",
                        step0_Q2: "",
                        step0_Q3: "",
                        step0_Q4: "person",
                        step0_Q5: "",
                        step0_Q6: "",
                        step0_Q7: "",

                        step: data.form.step ?? "1",
                        getPreAuthFormData: data,

                        step1_section2_disease: data.form.diseaseInfo.length === 0 ? [
                            {
                                diseaseCode: "",
                                surgeryCode: "",
                            }
                        ] : handledDiseaseInfo,

                        step1_section2_attendDoctor: data.form.attendDoctor,
                        step1_section2_isBxNetwork: data.form.isBxNetwork === "Y",

                        step1_section2_operationloctype: data.form.operationloctype ?? "HOSPITAL",
                        step1_section2_location: data.form.location ?? "HKMU",
                        step1_section2_hospitalid: hospitalItem ?? {},
                        step1_section2_otherhopsital: data.form.otherhopsital,

                        step1_section2_housingclass: data.form.housingclass,
                        step1_section3_admissiondt: data.form.admissiondt,
                        step1_section3_surgeryBudgetRemark: data.form.surgeryBudgetRemark ?? "",

                        step1_section3_provideMedicalExpense: data.form.provideMedicalExpense === "Y",
                        step1_section3_surgeonfee_checkbox: !!data.form.surgeonfee,
                        step1_section3_surgeonfee: data.form.surgeonfee,
                        step1_section3_anesthesiologistfee_checkbox: !!data.form.anesthesiologistfee,
                        step1_section3_anesthesiologistfee: data.form.anesthesiologistfee,
                        step1_section3_operatingrmfee_checkbox: !!data.form.operatingrmfee,
                        step1_section3_operatingrmfee: data.form.operatingrmfee,
                        step1_section3_housetourfee_noofdays_checkbox: !!data.form.housetourfee,
                        step1_section3_housetourfee: data.form.housetourfee,
                        step1_section3_hosmisousfee_checkbox: !!data.form.hosmisousfee,
                        step1_section3_hosmisousfee: data.form.hosmisousfee,
                        step1_section3_noofdays: data.form.noofdays,

                        step1_notToPaid: data.form.notToPaid === "Y",

                        step2_doc: data?.attachment ?? [],
                        step2_upload_option1: data.form.provideDoc === "Y",
                        step2_upload_option2: data.form.provideDoc === "N",

                        step3_email: data.form.userEmail,
                    });

                    validateStep1();
                    validateStep2();
                    validateStep3();
                },
                cancelCallback: () => {
                    resetApplyData();

                    set({
                        step0_Q1: "",
                        step0_Q2: "",
                        step0_Q3: "",
                        step0_Q4: "person",
                        step0_Q5: "",
                        step0_Q6: "",
                        step0_Q7: "",

                        step: "1",
                        getPreAuthFormData: data,
                    });
                },
                modalConfirmPrimaryButtonText: i18n.t("translation:apply.step0.popup.btn1"),
                modalConfirmSecondaryButtonText: i18n.t("translation:apply.step0.popup.btn2"),
            });
        }
    },

    getPreAuthFormForStep4: async () => {
        const { hospitalList, isLogCase, step1_notToPaid } = get();
        const { validateStep1, validateStep2, validateStep3 } = get();

        const { token } = useAuthStore.getState();
        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/getPreAuthForm`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });

        if (response.status === 401) { // Unauthorized
            throw new Error('Unauthorized Signin');
        }

        if (!response.ok) {
            throw new Error('Network Error');
        }

        const data = await response.json();

        const hospital = data.form.hospitalid ? hospitalList.find(item => item.hid === data.form.hospitalid) : {};
        const hospitalItem = hospital ? {
            value: data.form.hospitalid,
            label: i18n.language === "ch" ? hospital.chi_name : hospital.eng_name,
            color: "var(--aia-bx-dark-blue)",
        } : {};

        const handledDiseaseInfo = data.form.diseaseInfo.map((item) => {
            return {
                ...item,
                diseaseCode: item.diseaseOther ? `${item.diseaseCode}|${item.diseaseOther}` : item.diseaseCode,
            }
        });

        set({
            getPreAuthFormData: data,

            step1_section2_disease: data.form.diseaseInfo.length === 0 ? [
                {
                    diseaseCode: "",
                    surgeryCode: "",
                }
            ] : handledDiseaseInfo,

            step1_section2_attendDoctor: data.form.attendDoctor,
            step1_section2_isBxNetwork: data.form.isBxNetwork === "Y",

            step1_section2_operationloctype: data.form.operationloctype ?? "HOSPITAL",
            step1_section2_location: data.form.location ?? "HKMU",
            step1_section2_hospitalid: hospitalItem ?? {},
            step1_section2_otherhopsital: data.form.otherhopsital,

            step1_section2_housingclass: data.form.housingclass,
            step1_section3_admissiondt: data.form.admissiondt,
            step1_section3_surgeryBudgetRemark: data.form.surgeryBudgetRemark ?? "",

            step1_section3_provideMedicalExpense: data.form.provideMedicalExpense === "Y",
            step1_section3_surgeonfee_checkbox: !!data.form.surgeonfee,
            step1_section3_surgeonfee: data.form.surgeonfee,
            step1_section3_anesthesiologistfee_checkbox: !!data.form.anesthesiologistfee,
            step1_section3_anesthesiologistfee: data.form.anesthesiologistfee,
            step1_section3_operatingrmfee_checkbox: !!data.form.operatingrmfee,
            step1_section3_operatingrmfee: data.form.operatingrmfee,
            step1_section3_housetourfee: data.form.housetourfee,
            step1_section3_housetourfee_noofdays_checkbox: !!data.form.housetourfee,
            step1_section3_hosmisousfee_checkbox: !!data.form.hosmisousfee,
            step1_section3_hosmisousfee: data.form.hosmisousfee,
            step1_section3_noofdays: data.form.noofdays,

            step1_notToPaid: data.form.notToPaid === "Y",

            step2_doc: data?.attachment ?? [],
            step2_upload_option1: data.form.provideDoc === "Y",
            step2_upload_option2: data.form.provideDoc === "N",

            step3_email: data.form.userEmail,
        });

        validateStep1();
        validateStep2();
        validateStep3();

        const isLOGCaseAndNoHospitalBillsToPayFrontend = isLogCase() && !step1_notToPaid;
        const isLOGCaseAndNoHospitalBillsToPayBackend = data.form.triggerPaymentGateway === "Y";

        if (isLOGCaseAndNoHospitalBillsToPayFrontend !== isLOGCaseAndNoHospitalBillsToPayBackend) {
            feWriteLog(`isLOGCaseAndNoHospitalBillsToPayFrontend: ${isLOGCaseAndNoHospitalBillsToPayFrontend ? "true" : "false"}, isLOGCaseAndNoHospitalBillsToPayBackend: ${isLOGCaseAndNoHospitalBillsToPayBackend ? "Y" : "N"}, isLogCase(): ${isLogCase() ? "true" : "false"}, step1_notToPaid: ${step1_notToPaid ? "true" : "false"}`);
        }
    },

    // Data: 手術醫院 List
    hospitalList: [],
    getHospitalList: async () => {
        const response = await fetch(`${apiDomain}/${basename}/api/general/GetHospitalList`);
        const data = await response.json();
        set({ hospitalList: data.hospital })
    },

    // Step 1 Section 2 Area 1
    step1_section2_disease: [
        {
            diseaseCode: "",
            surgeryCode: "",
        }
    ],
    step1_section2_disease_error: [
        {
            diseaseCode: false,
            surgeryCode: [false],
        }
    ],
    setStep1_section2_disease: (diseaseIndex, value, previousDiseaseCode) => set((state) => {
        const newDiseaseArray = [...state.step1_section2_disease];

        if (diseaseIndex < newDiseaseArray.length) {
            const disease = newDiseaseArray[diseaseIndex].diseaseCode;
            const oldDiseaseCode = disease.includes("|") ? disease.split("|")[0] : disease;
            const oldDiseaseOther = disease.includes("|") ? disease.split("|")[1] : "";
            const newDiseaseCode = value.includes("|") ? value.split("|")[0] : value;
            const newDiseaseOther = value.includes("|") ? value.split("|")[1] : "";

            if (oldDiseaseCode !== newDiseaseCode) {
                newDiseaseArray[diseaseIndex].surgeryCode = "";
            }

            newDiseaseArray[diseaseIndex].diseaseCode = value;
        } else {
            newDiseaseArray.push({
                diseaseCode: value,
                surgeryCode: "",
            });
        }

        const newDiseaseErrorArray = [...state.step1_section2_disease_error];
        if (diseaseIndex < newDiseaseErrorArray.length) {
            newDiseaseErrorArray[diseaseIndex].diseaseCode = false;
            newDiseaseErrorArray[diseaseIndex].surgeryCode = [false];
        } else {
            newDiseaseErrorArray.push({
                diseaseCode: false,
                surgeryCode: [false],
            });
        }

        return {
            step1_section2_disease: newDiseaseArray,
            step1_section2_disease_error: newDiseaseErrorArray
        };
    }),
    setStep1_section2_disease_remove: (diseaseIndex) => set((state) => {
        const newDiseaseArray = [...state.step1_section2_disease];
        newDiseaseArray.splice(diseaseIndex, 1);
        const newSurgeryArray = [...state.step1_section2_disease_error];
        newSurgeryArray.splice(diseaseIndex, 1);
        return {
            step1_section2_disease: newDiseaseArray,
            step1_section2_disease_error: newSurgeryArray
        };
    }),
    setStep1_section2_surgery: (diseaseIndex, surgeryIndex, value) => set((state) => {
        const newDiseaseArray = [...state.step1_section2_disease];
        const newSurgeryCodeArray = newDiseaseArray[diseaseIndex].surgeryCode.split(",");
        const surgeryCodeLength = newSurgeryCodeArray.length;

        if (surgeryIndex < surgeryCodeLength) {
            newSurgeryCodeArray[surgeryIndex] = value;
        } else {
            newSurgeryCodeArray.push(value);
        }

        newDiseaseArray[diseaseIndex].surgeryCode = newSurgeryCodeArray.join(",");


        const newDiseaseErrorArray = [...state.step1_section2_disease_error];

        if (diseaseIndex < newDiseaseErrorArray.length) {
            newDiseaseErrorArray[diseaseIndex].surgeryCode[surgeryIndex] = false;
        }

        return {
            step1_section2_disease: newDiseaseArray,
            step1_section2_disease_error: newDiseaseErrorArray
        };
    }),
    setStep1_section2_surgery_remove: (diseaseIndex, surgeryIndex) => set((state) => {
        const newDiseaseArray = [...state.step1_section2_disease];
        const newSurgeryCodeArray = newDiseaseArray[diseaseIndex].surgeryCode.split(",");
        newSurgeryCodeArray.splice(surgeryIndex, 1);
        newDiseaseArray[diseaseIndex].surgeryCode = newSurgeryCodeArray.join(",");
        return { step1_section2_disease: newDiseaseArray };
    }),
    setStep1_section2_disease_set_error: (diseaseIndex, value) => set((state) => {
        const newErrorArray = [...state.step1_section2_disease_error];
        newErrorArray[diseaseIndex].diseaseCode = value;
        return { step1_section2_disease_error: newErrorArray };
    }),
    setStep1_section2_surgery_set_error: (diseaseIndex, surgeryIndex, value) => set((state) => {
        const newErrorArray = [...state.step1_section2_disease_error];
        newErrorArray[diseaseIndex].surgeryCode[surgeryIndex] = value;
        return { step1_section2_disease_error: newErrorArray };
    }),
    validateStep1Section2Area1: (checkOnly) => {
        const { step1_section2_disease } = get();
        const newErrorArray = [];
        let isValid = true;

        for (const item of step1_section2_disease) {
            const isOtherDisease = item.diseaseCode.includes("|");

            const diseaseCodeError = isOtherDisease ? item.diseaseCode.split("|")[1] === "" : !item.diseaseCode;
            const surgeryCodeError = item.surgeryCode.split(",").map((surgery) => {
                return surgery.includes("|") ? surgery.split("|")[1] === "" : !surgery;
            });

            newErrorArray.push({
                diseaseCode: diseaseCodeError,
                surgeryCode: surgeryCodeError,
            });

            if (diseaseCodeError || surgeryCodeError.some((surgery) => surgery)) {
                isValid = false;
            }
        }

        if (!checkOnly) {
            set({ step1_section2_disease_error: newErrorArray });
        }

        return isValid;
    },

    // Step 1 Section 2 Area 2
    step1_section2_attendDoctor: "",
    step1_section2_attendDoctor_error: false,
    setStep1_section2_attendDoctor: (value) => set({ step1_section2_attendDoctor: value }),
    setStep1_section2_attendDoctor_error: (value) => set({ step1_section2_attendDoctor_error: value }),

    step1_section2_isBxNetwork: false,
    setStep1_section2_isBxNetwork: (value) => set({ step1_section2_isBxNetwork: value }),

    validateStep1Section2Area2: (checkOnly) => {
        const { step1_section2_attendDoctor } = get();
        const isValid = !!step1_section2_attendDoctor;

        if (!checkOnly) {
            set({ step1_section2_attendDoctor_error: !isValid });
        }

        return isValid;
    },

    // Step 1 Section 2 Area 3
    step1_section2_operationloctype: "HOSPITAL", // HOSPITAL / DAYCENTRE
    setStep1_section2_operationloctype: (value) => set({ step1_section2_operationloctype: value }),

    step1_section2_location: "HKMU", // HKMU / OTHER
    step1_section2_location_error: false,
    setStep1_section2_location: (value) => set({ step1_section2_location: value }),
    setStep1_section2_location_error: (value) => set({ step1_section2_location_error: value }),

    step1_section2_hospitalid: {},
    step1_section2_hospitalid_error: false,
    setStep1_section2_hospitalid: (value) => set({ step1_section2_hospitalid: value }),
    setStep1_section2_hospitalid_error: (value) => set({ step1_section2_hospitalid_error: value }),

    step1_section2_otherhopsital: "",
    step1_section2_otherhopsital_error: false,
    setStep1_section2_otherhopsital: (value) => set({ step1_section2_otherhopsital: value }),
    setStep1_section2_otherhopsital_error: (value) => set({ step1_section2_otherhopsital_error: value }),

    step1_section2_housingclass: "", // REGULAR / SEMI / PRIVATE / DAYCASE / OUTPATIENT_CLINICAL
    step1_section2_housingclass_error: false,
    setStep1_section2_housingclass: (value) => set({ step1_section2_housingclass: value }),
    setStep1_section2_housingclass_error: (value) => set({ step1_section2_housingclass_error: value }),

    step1_section3_admissiondt: "",
    step1_section3_admissiondt_error: false,
    setStep1_section3_admissiondt: (value) => set({ step1_section3_admissiondt: value }),
    setStep1_section3_admissiondt_error: (value) => set({ step1_section3_admissiondt_error: value }),

    step1_section3_surgeryBudgetRemark: "",
    setStep1_section3_surgeryBudgetRemark: (value) => set({ step1_section3_surgeryBudgetRemark: value }),

    validateStep1Section2Area3: (checkOnly) => {
        const {
            step1_section2_operationloctype,
            step1_section2_location,
            step1_section2_hospitalid,
            step1_section2_otherhopsital,
            step1_section2_housingclass,
            step1_section3_admissiondt
        } = get();

        const {
            setStep1_section2_location_error,
            setStep1_section2_hospitalid_error,
            setStep1_section2_otherhopsital_error,
            setStep1_section2_housingclass_error,
            setStep1_section3_admissiondt_error
        } = get();

        const validateHospital = () => {
            if (step1_section2_operationloctype === "HOSPITAL") {
                if (step1_section2_location === "HKMU") {
                    if (!step1_section2_hospitalid?.value) {
                        if (!checkOnly) {
                            setStep1_section2_hospitalid_error(true);
                        }
                        return false;
                    } else if (step1_section2_hospitalid?.value === "00000000000000000000000000000000" && !step1_section2_otherhopsital) {
                        if (!checkOnly) {
                            setStep1_section2_otherhopsital_error(true);
                        }
                        return false;
                    }
                } else if (step1_section2_location === "OTHER" && !step1_section2_otherhopsital) {
                    if (!checkOnly) {
                        setStep1_section2_otherhopsital_error(true);
                    }
                    return false;
                }
            } else if (step1_section2_operationloctype === "DAYCENTRE" && !step1_section2_otherhopsital) {
                if (!checkOnly) {
                    setStep1_section2_otherhopsital_error(true);
                }
                return false;
            }
            return true;
        };

        const isHospitalValid = validateHospital();
        const isHousingClassValid = !!step1_section2_housingclass;
        const isAdmissionDateValid = !!step1_section3_admissiondt;

        if (!checkOnly) {
            setStep1_section2_housingclass_error(!isHousingClassValid);
            setStep1_section3_admissiondt_error(!isAdmissionDateValid);
        }

        return isHospitalValid && isHousingClassValid && isAdmissionDateValid;
    },

    // Step 1 Section 2 Area 4
    step1_section3_provideMedicalExpense: false,
    step1_section3_provideMedicalExpense_error: false,
    setStep1_section3_provideMedicalExpense: (value) => set({ step1_section3_provideMedicalExpense: value }),
    setStep1_section3_provideMedicalExpense_error: (value) => set({ step1_section3_provideMedicalExpense_error: value }),

    step1_section3_surgeonfee: "",
    step1_section3_surgeonfee_checkbox: false,
    step1_section3_surgeonfee_error: false,
    setStep1_section3_surgeonfee: (value) => set({ step1_section3_surgeonfee: value }),
    setStep1_section3_surgeonfee_checkbox: (value) => set({ step1_section3_surgeonfee_checkbox: value }),
    setStep1_section3_surgeonfee_error: (value) => set({ step1_section3_surgeonfee_error: value }),

    step1_section3_anesthesiologistfee: "",
    step1_section3_anesthesiologistfee_checkbox: false,
    step1_section3_anesthesiologistfee_error: false,
    setStep1_section3_anesthesiologistfee: (value) => set({ step1_section3_anesthesiologistfee: value }),
    setStep1_section3_anesthesiologistfee_checkbox: (value) => set({ step1_section3_anesthesiologistfee_checkbox: value }),
    setStep1_section3_anesthesiologistfee_error: (value) => set({ step1_section3_anesthesiologistfee_error: value }),

    step1_section3_operatingrmfee: "",
    step1_section3_operatingrmfee_checkbox: false,
    step1_section3_operatingrmfee_error: false,
    setStep1_section3_operatingrmfee: (value) => set({ step1_section3_operatingrmfee: value }),
    setStep1_section3_operatingrmfee_checkbox: (value) => set({ step1_section3_operatingrmfee_checkbox: value }),
    setStep1_section3_operatingrmfee_error: (value) => set({ step1_section3_operatingrmfee_error: value }),

    step1_section3_hosmisousfee: "",
    step1_section3_hosmisousfee_checkbox: false,
    step1_section3_hosmisousfee_error: false,
    setStep1_section3_hosmisousfee: (value) => set({ step1_section3_hosmisousfee: value }),
    setStep1_section3_hosmisousfee_checkbox: (value) => set({ step1_section3_hosmisousfee_checkbox: value }),
    setStep1_section3_hosmisousfee_error: (value) => set({ step1_section3_hosmisousfee_error: value }),

    step1_section3_housetourfee: "",
    step1_section3_housetourfee_error: false,
    setStep1_section3_housetourfee: (value) => set({ step1_section3_housetourfee: value }),
    setStep1_section3_housetourfee_error: (value) => set({ step1_section3_housetourfee_error: value }),

    step1_section3_noofdays: "",
    step1_section3_noofdays_error: false,
    setStep1_section3_noofdays: (value) => set({ step1_section3_noofdays: value }),
    setStep1_section3_noofdays_error: (value) => set({ step1_section3_noofdays_error: value }),

    step1_section3_housetourfee_noofdays_checkbox: false,
    setStep1_section3_housetourfee_noofdays_checkbox: (value) => set({ step1_section3_housetourfee_noofdays_checkbox: value }),

    step1_scrollTo: "",
    setStep1_scrollTo: (value) => set({ step1_scrollTo: value }),

    validateStep1Section2Area4: (checkOnly) => {
        const {
            step1_section3_provideMedicalExpense,
            step1_section3_surgeonfee,
            step1_section3_surgeonfee_checkbox,
            step1_section3_anesthesiologistfee,
            step1_section3_anesthesiologistfee_checkbox,
            step1_section3_operatingrmfee,
            step1_section3_operatingrmfee_checkbox,
            step1_section3_housetourfee,
            step1_section3_hosmisousfee_checkbox,
            step1_section3_hosmisousfee,
            step1_section3_noofdays,
            step1_section3_housetourfee_noofdays_checkbox,
            setStep1_section3_provideMedicalExpense_error,
            setStep1_section3_surgeonfee_error,
            setStep1_section3_anesthesiologistfee_error,
            setStep1_section3_operatingrmfee_error,
            setStep1_section3_housetourfee_error,
            setStep1_section3_hosmisousfee_error,
            setStep1_section3_noofdays_error,
        } = get();

        const isNumber = (value) => {
            return !isNaN(value) && typeof value === 'number' && Number.isFinite(value);
        };

        const isSurgeonFeeValid = step1_section3_provideMedicalExpense && step1_section3_surgeonfee_checkbox ? isNumber(parseFloat(step1_section3_surgeonfee)) : true;
        const isAnesthesiologistFeeValid = step1_section3_provideMedicalExpense && step1_section3_anesthesiologistfee_checkbox ? isNumber(parseFloat(step1_section3_anesthesiologistfee)) : true;
        const isOperatingRmFeeValid = step1_section3_provideMedicalExpense && step1_section3_operatingrmfee_checkbox ? isNumber(parseFloat(step1_section3_operatingrmfee)) : true;
        const isHouseTourFeeValid = step1_section3_provideMedicalExpense && step1_section3_housetourfee_noofdays_checkbox ? isNumber(parseFloat(step1_section3_housetourfee)) : true;
        const isHosMisousFeeValid = step1_section3_provideMedicalExpense && step1_section3_hosmisousfee_checkbox ? isNumber(parseFloat(step1_section3_hosmisousfee)) : true;
        const isNoOfDaysValid = step1_section3_provideMedicalExpense && step1_section3_housetourfee_noofdays_checkbox ? isNumber(parseFloat(step1_section3_noofdays)) : true;
        const isStep1_section3_provideMedicalExpenseValid =
            step1_section3_provideMedicalExpense === false ||
            (
                step1_section3_provideMedicalExpense &&
                (
                    step1_section3_surgeonfee_checkbox ||
                    step1_section3_anesthesiologistfee_checkbox ||
                    step1_section3_operatingrmfee_checkbox ||
                    step1_section3_hosmisousfee_checkbox ||
                    step1_section3_housetourfee_noofdays_checkbox ||
                    step1_section3_housetourfee_noofdays_checkbox
                )
            );

        if (!checkOnly) {
            setStep1_section3_surgeonfee_error(!isSurgeonFeeValid);
            setStep1_section3_anesthesiologistfee_error(!isAnesthesiologistFeeValid);
            setStep1_section3_operatingrmfee_error(!isOperatingRmFeeValid);
            setStep1_section3_housetourfee_error(!isHouseTourFeeValid);
            setStep1_section3_hosmisousfee_error(!isHosMisousFeeValid);
            setStep1_section3_noofdays_error(!isNoOfDaysValid);
            setStep1_section3_provideMedicalExpense_error(!isStep1_section3_provideMedicalExpenseValid);
        }

        return isStep1_section3_provideMedicalExpenseValid && isSurgeonFeeValid && isAnesthesiologistFeeValid && isOperatingRmFeeValid && isHouseTourFeeValid && isHosMisousFeeValid && isNoOfDaysValid;
    },

    step1_notToPaid: true,
    setStep1_notToPaid: (value) => set({ step1_notToPaid: value }),

    isStep1Valid: false,
    validateStep1: (checkOnly) => {
        const { validateStep1Section2Area1, validateStep1Section2Area2, validateStep1Section2Area3, validateStep1Section2Area4 } = get();
        const { setStep1_scrollTo } = get();

        let isValid = true;

        if (!validateStep1Section2Area1(checkOnly)) {
            if (isValid && !checkOnly) {
                setStep1_scrollTo("area1");
            }
            isValid = false;
        }

        if (!validateStep1Section2Area2(checkOnly)) {
            if (isValid && !checkOnly) {
                setStep1_scrollTo("area2");
            }
            isValid = false;
        }

        if (!validateStep1Section2Area3(checkOnly)) {
            if (isValid && !checkOnly) {
                setStep1_scrollTo("area3");
            }
            isValid = false;
        }

        if (!validateStep1Section2Area4(checkOnly)) {
            if (isValid && !checkOnly) {
                setStep1_scrollTo("area4");
            }
            isValid = false;
        }

        set({ isStep1Valid: isValid });
        return isValid;
    },

    isLogCase: () => {
        const { step1_section2_operationloctype, step1_section2_location, step1_section2_hospitalid, step1_section2_housingclass } = get();

        return step1_section2_operationloctype === "HOSPITAL" && step1_section2_location === "HKMU" && !!step1_section2_hospitalid?.value && step1_section2_hospitalid?.value !== "00000000000000000000000000000000" && step1_section2_housingclass !== "DAYCASE" && step1_section2_housingclass !== "OUTPATIENT_CLINICAL"
    },

    saveFormStep1: withErrorHandling(async () => {
        const { saveForm } = get();
        const { step1_section2_disease } = get();
        const { step1_section2_attendDoctor, step1_section2_isBxNetwork } = get();
        const { step1_section2_operationloctype, step1_section2_location, step1_section2_hospitalid, step1_section2_otherhopsital } = get();
        const { step1_section2_housingclass, step1_section3_admissiondt, step1_section3_surgeryBudgetRemark } = get();
        const { step1_section3_provideMedicalExpense, step1_section3_surgeonfee, step1_section3_anesthesiologistfee, step1_section3_operatingrmfee, step1_section3_housetourfee, step1_section3_hosmisousfee, step1_section3_noofdays } = get();
        const { step1_section3_surgeonfee_checkbox, step1_section3_anesthesiologistfee_checkbox, step1_section3_operatingrmfee_checkbox, step1_section3_hosmisousfee_checkbox, step1_section3_housetourfee_noofdays_checkbox } = get();
        const { step1_notToPaid } = get();

        await saveForm({
            step: "1",

            diseaseInfo: step1_section2_disease.map((item) => {
                const diseaseCode = item.diseaseCode.includes("|") ? item.diseaseCode.split("|")[0] : item.diseaseCode;
                const diseaseOther = item.diseaseCode.includes("|") ? item.diseaseCode.split("|")[1] : "";

                return {
                    diseaseCode: diseaseCode,
                    diseaseOther: diseaseOther,
                    surgeryCode: item.surgeryCode,
                }
            }),

            attendDoctor: step1_section2_attendDoctor,
            isBxNetwork: step1_section2_isBxNetwork ? "Y" : "N",

            operationloctype: step1_section2_operationloctype,
            location: step1_section2_location,
            hospitalid: step1_section2_operationloctype === "HOSPITAL" && step1_section2_location === "HKMU" ? step1_section2_hospitalid?.value ?? "" : "",
            otherhopsital: (
                (step1_section2_operationloctype === "HOSPITAL" && step1_section2_location === "HKMU" && step1_section2_hospitalid?.value === "00000000000000000000000000000000") ||
                (step1_section2_operationloctype === "HOSPITAL" && step1_section2_location === "OTHER" && step1_section2_otherhopsital) ||
                (step1_section2_operationloctype === "DAYCENTRE")
            ) ? step1_section2_otherhopsital : "",
            housingclass: step1_section2_housingclass,
            admissiondt: step1_section3_admissiondt,
            surgeryBudgetRemark: step1_section3_surgeryBudgetRemark,

            provideMedicalExpense: step1_section3_provideMedicalExpense ? "Y" : "N",
            surgeonfee: step1_section3_surgeonfee_checkbox ? step1_section3_surgeonfee : "",
            anesthesiologistfee: step1_section3_anesthesiologistfee_checkbox ? step1_section3_anesthesiologistfee : "",
            operatingrmfee: step1_section3_operatingrmfee_checkbox ? step1_section3_operatingrmfee : "",
            housetourfee: step1_section3_housetourfee_noofdays_checkbox ? step1_section3_housetourfee : "",
            hosmisousfee: step1_section3_hosmisousfee_checkbox ? step1_section3_hosmisousfee : "",
            noofdays: step1_section3_housetourfee_noofdays_checkbox ? step1_section3_noofdays : "",

            notToPaid: step1_notToPaid ? "Y" : "N",
        });
    }),

    // Step 2
    step2_upload_option1: false,
    setStep2_upload_option1: (value) => set({ step2_upload_option1: value }),

    step2_upload_option2: false,
    setStep2_upload_option2: (value) => set({ step2_upload_option2: value }),

    step2_doc: [],
    step2_doc_error: false,
    setStep2_doc: (value) => set({ step2_doc: value }),
    addStep2_doc: newState =>
        set(prevState => {
            return {
                step2_doc: [...prevState.step2_doc, newState]
            }
        }),
    setStep2_doc_error: (value) => set({ step2_doc_error: value }),

    step2_doc_option_error: false,
    setStep2_doc_option_error: (value) => set({ step2_doc_option_error: value }),

    step2_scrollTo: "",
    setStep2_scrollTo: (value) => set({ step2_scrollTo: value }),

    isStep2Valid: false,
    validateStep2: (checkOnly) => {
        const { step2_doc, step2_upload_option1, step2_upload_option2, setStep2_scrollTo } = get();

        const isValid = (step2_upload_option1 && step2_doc.length > 0) || step2_upload_option2;

        set({
            isStep2Valid: isValid,
        })

        if (!checkOnly) {
            if (!step2_upload_option1 && !step2_upload_option2) {
                set({
                    step2_doc_option_error: true,
                })
            }

            if (step2_upload_option1 && step2_doc.length === 0) {
                set({
                    step2_doc_error: true,
                })
            }

            if (!isValid) {
                setStep2_scrollTo("upload");
            }
        }

        return isValid;
    },

    saveFormStep2: withErrorHandling(async () => {
        const { saveForm } = get();
        const { step2_upload_option1 } = get();

        await saveForm({
            step: "2",
            provideDoc: step2_upload_option1 ? "Y" : "N",
        });
    }),

    // Step 3
    step3_email: "",
    step3_email_error: false,
    setStep3_email: (value) => set({ step3_email: value }),
    setStep3_email_error: (value) => set({ step3_email_error: value }),

    step3_email_confirm: "",
    step3_email_confirm_error: false,
    setStep3_email_confirm: (value) => set({ step3_email_confirm: value }),
    setStep3_email_confirm_error: (value) => set({ step3_email_confirm_error: value }),

    step3_mobile: "",
    step3_mobile_error: false,
    setStep3_mobile: (value) => set({ step3_mobile: value }),
    setStep3_mobile_error: (value) => set({ step3_mobile_error: value }),

    step3_mobile_confirm: "",
    step3_mobile_confirm_error: false,
    setStep3_mobile_confirm: (value) => set({ step3_mobile_confirm: value }),
    setStep3_mobile_confirm_error: (value) => set({ step3_mobile_confirm_error: value }),

    step3_sync: false,
    setStep3_sync: (value) => set({ step3_sync: value }),

    // Value: 保單號碼
    step3_Q1: "",
    step3_Q1Error: false,
    setStep3_Q1: (value) => set({ step3_Q1: value }),
    setStep3_Q1Error: (value) => set({ step3_Q1Error: value }),

    // Value: 受保人（病人）於該保單之身份為
    step3_Q4: "person",  // person, spouse_children
    setStep3_Q4: (value) => set({ step3_Q4: value }),

    // Value: 受保人（病人）之成員號碼
    step3_Q5: "",
    step3_Q5Error: false,
    setStep3_Q5: (value) => set({ step3_Q5: value }),
    setStep3_Q5Error: (value) => set({ step3_Q5Error: value }),

    // Value: 申請人受保人號碼
    step3_Q6: "",
    step3_Q6Error: false,
    setStep3_Q6: (value) => set({ step3_Q6: value }),
    setStep3_Q6Error: (value) => set({ step3_Q6Error: value }),

    // Value: 配偶或子女受保人號碼
    step3_Q7: "",
    step3_Q7Error: false,
    setStep3_Q7: (value) => set({ step3_Q7: value }),
    setStep3_Q7Error: (value) => set({ step3_Q7Error: value }),

    step3_scrollTo: "",
    setStep3_scrollTo: (value) => set({ step3_scrollTo: value }),

    isStep3Valid: false,
    validateStep3: (checkOnly) => {
        const { step3_email, setStep3_email_error, step3_email_confirm, setStep3_email_confirm_error } = get();
        const { step3_mobile, setStep3_mobile_error, step3_mobile_confirm, setStep3_mobile_confirm_error } = get();
        const { step3_sync, step3_scrollTo } = get();
        const { step3_Q1, setStep3_Q1Error } = get();
        const { step3_Q4 } = get();
        const { step3_Q5, setStep3_Q5Error } = get();
        const { step3_Q6, setStep3_Q6Error } = get();
        const { step3_Q7, setStep3_Q7Error } = get();
        const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobileReg = /^[0-9]+$/;

        const validations = [
            { condition: !emailReg.test(step3_email), setError: setStep3_email_error, scrollTo: "email" },
            { condition: step3_email !== step3_email_confirm, setError: setStep3_email_confirm_error, scrollTo: "email" },
            { condition: !mobileReg.test(step3_mobile), setError: setStep3_mobile_error, scrollTo: "mobile" },
            { condition: step3_mobile !== step3_mobile_confirm, setError: setStep3_mobile_confirm_error, scrollTo: "mobile" },
            { condition: !!step3_sync && !step3_Q1, setError: setStep3_Q1Error, scrollTo: "sync" },
            { condition: !!step3_sync && step3_Q4 === "person" && !step3_Q5, setError: setStep3_Q5Error, scrollTo: "sync" },
            { condition: !!step3_sync && step3_Q4 === "spouse_children" && !step3_Q6, setError: setStep3_Q6Error, scrollTo: "sync" },
            { condition: !!step3_sync && step3_Q4 === "spouse_children" && !step3_Q7, setError: setStep3_Q7Error, scrollTo: "sync" }
        ];

        let allValid = true;

        validations.forEach(({ condition, setError, scrollTo }) => {
            if (condition) {
                if (!checkOnly) {
                    setError(true);
                    if (allValid && !step3_scrollTo && scrollTo) {
                        set({ step3_scrollTo: scrollTo });
                    }
                }
                allValid = false;
            }
        });

        set({
            isStep3Valid: allValid
        })
        return allValid;
    },

    saveFormStep3: withErrorHandling(async () => {
        const { saveForm } = get();
        const { step3_email, step3_mobile, step3_sync, step3_Q1, step3_Q4, step3_Q5, step3_Q6, step3_Q7 } = get();

        await saveForm({
            step: "3",
            userEmail: step3_email,
            userTel: step3_mobile,
            withOtherApplication: step3_sync ? "Y" : "N",
            otherPolicyNo: step3_sync ? step3_Q1 : "",
            otherInsurNo: step3_sync ? step3_Q4 === "person" ? step3_Q5 : step3_Q6 : "",
            otherDependCode: step3_sync && step3_Q4 === "spouse_children" ? step3_Q7 : "",
        });
    }),

    // Step 4

    step4_accept: false,
    step4_accept_error: false,
    setStep4_accept: (value) => set({ step4_accept: value }),
    setStep4_accept_error: (value) => set({ step4_accept_error: value }),

    step4_pay_accept: false,
    step4_pay_accept_error: false,
    setStep4_pay_accept: (value) => set({ step4_pay_accept: value }),
    setStep4_pay_accept_error: (value) => set({ step4_pay_accept_error: value }),

    isStep4Valid: false,
    validateStep4: (checkOnly) => {
        const { step4_accept, setStep4_accept_error } = get();
        const { isLogCase, getPreAuthFormData, step1_notToPaid, step4_pay_accept, setStep4_pay_accept_error } = get();

        let isValid = true;

        if (!step4_accept) {
            if (!checkOnly) {
                setStep4_accept_error(true);
            }
            isValid = false;
        }

        // if (isLogCase() && !step1_notToPaid && !step4_pay_accept) {
        if (getPreAuthFormData?.form?.triggerPaymentGateway === "Y" && !step4_pay_accept) {
            if (!checkOnly) {
                setStep4_pay_accept_error(true);
            }
            isValid = false;
        }

        set({
            isStep4Valid: isValid
        })
        return isValid;
    },

    goMPGSPayment: withErrorHandling(async () => {
        const { token, logout } = useAuthStore.getState();
        const langCode = i18n.language === "ch" ? "zh-hk" : "en_us";

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/getMpgsSession?lang=${langCode}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });

        if (response.status === 401) { // Unauthorized
            logout();
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            throw new Error('Network Error');
        }

        const { data } = await response.json();

        const { sessionId, merchantId } = data;

        if (window.location.hostname === "bluecross.hashtechpro.com") {
            const { openModalConfirm } = useModalStore.getState();
            const { setStep, failPayment, completePayment, applicationSubmit } = get();
            const loadFailPayment = withErrorHandling(failPayment);

            openModalConfirm({
                title: "Payment Gateway Testing",
                text: "Choose payment success or fail",
                modalConfirmPrimaryButtonText: "Success",
                modalConfirmSecondaryButtonText: "Fail",
                callback: () => {
                    const finishPayment = withErrorHandling(async () => {
                        await completePayment();

                        const success = await applicationSubmit();

                        if (success) {
                            setStep("success");
                            window.history.pushState({}, '', `/${basename}/${i18n.language}/apply/success`);
                        } else {
                            setStep("submitFail");
                        }
                    });

                    finishPayment();
                },
                cancelCallback: () => {
                    setStep("paymentFail");
                    loadFailPayment();
                }
            });

        } else {
            /* eslint-disable */
            Checkout.configure({
                merchant: merchantId,
                session: {
                    id: sessionId
                },
                interaction: {
                    merchant: {
                        name: 'Blue Cross',
                    },
                    displayControl: {
                        paymentConfirmation: 'SHOW',
                        billingAddress: 'HIDE',
                        shipping: 'HIDE',
                    },
                    locale: langCode,
                }
            });
            Checkout.showLightbox();
            /* eslint-enable */
        }
    }),


    applicationSubmit: withErrorHandling(async () => {
        const { token } = useAuthStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/applicationSubmit`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        const data = await response.json();

        if (data.status === "SUCCESS") {
            set({
                refno: data.form.refno,
            });
        }

        return data.status === "SUCCESS";
    }),
    completePayment: withErrorHandling(async () => {
        const { token } = useAuthStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/completePayment`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        const data = await response.json();
        // console.log(data);
    }),
    failPayment: withErrorHandling(async () => {
        const { token } = useAuthStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/failPayment`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        // const data = await response.json();
        // console.log(data);
    }),

    refno: "",

    findDiseaseByCode: (diseaseCode) => {
        const { getPreAuthFormData } = get();

        for (const category of getPreAuthFormData?.diseaseOption) {
            const foundOption = category.options.find(option => option.diseaseCode === diseaseCode);
            if (foundOption) {
                return foundOption; // Return the found option
            }
        }
        return null; // Return null if not found
    },
    findSurgeriesByCode: (diseaseCode, surgeryCodes) => {
        const { getPreAuthFormData } = get();
        const result = []; // Array to hold matching surgery options

        // Find the disease entry that matches the provided diseaseCode
        const diseaseEntry = getPreAuthFormData?.SurgeryOption.find(entry => entry.diseaseCode === diseaseCode);

        if (diseaseEntry) {
            // Iterate through the surgery options
            for (const surgeryCode of surgeryCodes) {
                const foundSurgery = diseaseEntry.options.find(option => option.surgeryCode === surgeryCode);
                if (foundSurgery) {
                    result.push(foundSurgery); // Add found surgery to results
                }
            }
        }

        return result; // Return all found surgeries
    },

    stepSuccess_rateOverall: 5,
    stepSuccess_rateOverall_error: false,
    setStepSuccess_rateOverall: (value) => set({ stepSuccess_rateOverall: value }),
    setStepSuccess_rateOverall_error: (value) => set({ stepSuccess_rateOverall_error: value }),

    stepSuccess_rateImproveCode: "",
    stepSuccess_rateImproveCode_error: false,
    setStepSuccess_rateImproveCode: (value) => set({ stepSuccess_rateImproveCode: value }),
    setStepSuccess_rateImproveCode_error: (value) => set({ stepSuccess_rateImproveCode_error: value }),

    stepSuccess_rateCmt: "",
    stepSuccess_rateCmt_error: false,
    setStepSuccess_rateCmt: (value) => set({ stepSuccess_rateCmt: value }),
    setStepSuccess_rateCmt_error: (value) => set({ stepSuccess_rateCmt_error: value }),

    isRatingValid: false,
    validateRating: (checkOnly) => {
        const { setModalConfirmPrimaryButtonDisabled } = useModalStore.getState();
        const { stepSuccess_rateOverall, stepSuccess_rateImproveCode, stepSuccess_rateCmt, setStepSuccess_rateOverall_error, setStepSuccess_rateImproveCode_error, setStepSuccess_rateCmt_error } = get();

        const isOverallValid = !!stepSuccess_rateOverall;
        const isImproveCodeValid = !!stepSuccess_rateImproveCode;
        const isCmtValid = !!stepSuccess_rateCmt;

        if (!checkOnly) {
            setStepSuccess_rateOverall_error(!isOverallValid);
            setStepSuccess_rateImproveCode_error(!isImproveCodeValid);
            setStepSuccess_rateCmt_error(!isCmtValid);
        }

        const isCmtRequired = stepSuccess_rateOverall <= 3;
        const isValid = isOverallValid && isImproveCodeValid && (!isCmtRequired || isCmtValid);

        setModalConfirmPrimaryButtonDisabled(!isValid);
        set({
            isRatingValid: isValid
        })
        return isValid;
    },

    disableRatingSubmit: false,
    ratingSubmit: withErrorHandling(async () => {
        const { stepSuccess_rateOverall, stepSuccess_rateImproveCode, stepSuccess_rateCmt, getPreAuthFormData } = get();

        const { token } = useAuthStore.getState();

        const response = await fetch(`${apiDomain}/${basename}/api/preAuthCore/RatingSubmit`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                "rateOverall": stepSuccess_rateOverall,
                "rateImproveCode": stepSuccess_rateImproveCode,
                "rateCmt": stepSuccess_rateCmt,
                "aid": getPreAuthFormData.form.aid,
            })
        });

        set({
            stepSuccess_rateOverall: 5,
            stepSuccess_rateOverall_error: false,
            stepSuccess_rateImproveCode: "",
            stepSuccess_rateImproveCode_error: false,
            stepSuccess_rateCmt: "",
            stepSuccess_rateCmt_error: false,
            isRatingValid: false,
            disableRatingSubmit: true,
        });

        const data = await response.json();

        return data;
    }),

}))

export default useApplyNewStore;